<template>
  <!-- <section class="site-accordion">
        <div class="container">
            <div class="row">
                <div class="col s12 m12 l12">
                    <ul class="collapsible site-collapsible">
                        <li v-for="(item, index) in data" :key="index">
                            <div class="collapsible-header"><div class="ch-wrap">{{ getHeaderField(item) }}</div></div>
                            <div class="collapsible-body">
                                <span v-html="getContentField(item)"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section> -->
  <section class="site-accordion">
    <div class="container">
      <div class="row">
        <div class="col s12 m12 l12">
          <ul class="collapsible site-collapsible">
            <li>
              <div class="collapsible-header" tabindex="0">
                [placeholder accordion header ]<span
                  ><i class="material-icons">expand_more</i></span
                >
              </div>
              <div class="collapsible-body">
                <span>
                  <p>
                    [placeholder accordion item text]
                  </p>
                </span>
              </div>
            </li>
            <li>
              <div class="collapsible-header" tabindex="1">
                [placeholder accordion header ]<span
                  ><i class="material-icons">expand_more</i></span
                >
              </div>
              <div class="collapsible-body">
                <span>
                  <p>
                    [placeholder accordion item text]
                  </p>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l12">
          <p>
            [placeholder body text]
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Tables from "@/components/customPages/components/Table.vue";
export default {
  name: "site-accordionStatic",
  components: {
    Tables,
  },
  props: {
    data: Array,
    headerField: String,
    contentField: String,
  },
  mounted() {
    this.$nextTick(() => {
      let elems = document.querySelectorAll(".collapsible");
      let instances = M.Collapsible.init(elems, {});
    });
  },
  methods: {
    getHeaderField(item) {
      return item.properties[this.headerField];
    },
    getContentField(item) {
      return item.properties[this.contentField];
    },
  },
};
</script>
